(function () {
    'use strict';

    angular
        .module('salesflare.components.mainmenu', [])
        .component('sfMainMenu', {
            templateUrl: 'app-ajs/components/mainmenu/mainmenu.html',
            controller,
            controllerAs: 'vm'
        });

    function controller($document, $mdMedia, $state, $rootScope, $scope, $mdSidenav, $mdPanel, $timeout, model, utils, authentication, sfWalkthrough, sfContextualHelp, usersettings, flagsService, themeService, sfSetupPanel, statusBarService, $translate) {

        const vm = this;

        vm.currentUser = model.me;
        vm.sfContextualHelp = sfContextualHelp;
        vm.isSetupPanelActive = sfSetupPanel.isActive;

        let leadsWalkthrough = null;

        let unwatchSidenav;

        vm.$onInit = function () {

            unwatchSidenav = $scope.$watch(
                function () {
                    return $mdSidenav('menu').isOpen();
                },
                function (isOpen, wasOpen) {
                    if (isOpen === true && wasOpen !== true) {

                        if (!$mdMedia('gt-sm')) {
                            authentication.fetchMe();
                        }
                    }
                }
            );

            Intercom('onHide', function () {

                return $scope.$applyAsync(function () {

                    vm.supportChatActive = false;
                });
            });

            Intercom('onShow', function () {
                const theme = themeService.get();

                if (theme === 'dark') {
                    Intercom('update', {
                        theme_mode: 'dark'
                    });
                }
                else {
                    Intercom('update', {
                        theme_mode: 'light'
                    });
                }

                return $scope.$applyAsync(function () {

                    vm.supportChatActive = true;
                });
            });

            Intercom('onUnreadCountChange', function () {

                return $scope.$applyAsync(function () {

                    vm.supportChatActive = true;
                });
            });

            if (flagsService.get('showLeadsWalkthrough') === true && flagsService.get('showLeadSearch') === true && vm.shouldShowOnFullscreen() && !sfWalkthrough.isShowing()) {
                showLeadsWalkthrough();
            }
        };

        vm.shouldShowOnFullscreen = function () {

            return $mdMedia('gt-sm');
        };

        vm.getCompletionText = function () {
            return vm.currentUser.setup_completion_percentage + '%';
        };

        vm.openNotificationPanel = function () {

            vm.isNotificationPanelOpened = !vm.isNotificationPanelOpened;

            if (vm.isNotificationPanelOpened) {
                let position = $mdPanel.newPanelPosition();

                if ($mdMedia('gt-sm')) {
                    position = $mdPanel.newPanelPosition()
                        .relativeTo('.mainMenu')
                        .addPanelPosition($mdPanel.xPosition.OFFSET_END, $mdPanel.yPosition.ALIGN_TOPS);
                }

                return $mdPanel.open('notificationPanel', {
                    attachTo: $document[0].body,
                    position,
                    locals: {},
                    onRemoving: function () {

                        vm.isNotificationPanelOpened = false;
                        model.me.amountOfNotViewedNotifications = 0;
                        return usersettings.setLastVisitedNotificationsToNow();
                    }
                });
            }
        };

        vm.currentStateIncludes = function (testString) {

            return $state.includes(testString);
        };

        vm.toggleMenu = function () {

            return $mdSidenav('menu').toggle();
        };

        vm.workflowsEnabled = function () {

            return flagsService.get('workflowBeta');
        };

        vm.showNewFeatureIndicatorInsights = function () {

            return flagsService.get('showInsightsWalkthrough');
        };

        vm.showLeadSearch = function () {

            return flagsService.get('showLeadSearch');
        };

        vm.showLeadsWalkthrough = function () {

            return flagsService.get('showLeadsWalkthrough') && !vm.isWalkthroughShowing();
        };

        vm.hasDeal = function () {

            return (vm.currentUser && (vm.currentUser.team.total_user_count === 1 || vm.currentUser.team.free_users > 0) && vm.currentUser.team.discount_type === 'firstFreeThen50Off' && (new Date(vm.currentUser.team.creation_date) < new Date('2018-10-30')) && (new Date() < new Date(new Date('2018-11-10').setUTCHours(0, 0, 0, 0))));
        };

        vm.showSetupPercentage = function () {

            return utils.showSetupPercentage(vm.currentUser);
        };

        vm.showContextualHelp = function () {

            if (sfSetupPanel.isActive()) {
                return sfSetupPanel.close();
            }

            return sfContextualHelp.show();
        };

        vm.isWalkthroughShowing = sfWalkthrough.isShowing;

        vm.hideElement = sfWalkthrough.hideElement;

        vm.$onDestroy = function () {

            if (unwatchSidenav) {
                unwatchSidenav();
            }

            if (leadsWalkthrough) {
                leadsWalkthrough.cancel();
            }
        };

        function showLeadsWalkthrough() {

            // Don't show status bar during WT
            statusBarService.setCanBeVisible(false);

            $timeout(function () {

                if (vm.isWalkthroughShowing()) {
                    return;
                }

                leadsWalkthrough = new Shepherd.Tour({
                    defaultStepOptions: {
                        popperOptions: {
                            modifiers: [{ name: 'offset', options: { offset: [0, 20] } }]
                        }
                    }
                });

                leadsWalkthrough.addStep( {
                    title: $translate.instant('NEW: find leads'),
                    text: $translate.instant('Start filtering to find new leads in a specific location, industry, role, ... straight from Salesflare.'),
                    attachTo: {
                        element: '#leads-menu-item',
                        on: 'right'
                    },
                    buttons: [{
                        action: leadsWalkthrough.next,
                        text: $translate.instant('GOT IT!')
                    }]
                });

                leadsWalkthrough.on('complete', function () {

                    // Show status bar again
                    statusBarService.setCanBeVisible(true);

                    return flagsService.set('showLeadsWalkthrough', false);
                });

                return leadsWalkthrough.start();
            }, 2000);
        }
    }
})();
